import { NotificationPriorities } from "@elit-hair/elitklinik-shared/notification";
import { TbBell, TbBellRinging, TbUrgent, TbZzz } from "react-icons/tb";

import { CommonStatusItem } from "@/types/global";

import { softColors } from "./colors";

export type NotificationPriorityItem = CommonStatusItem & {
    value: NotificationPriorities;
};

export type NotificationPriorityList = NotificationPriorityItem[];

export const notificationPriorities: NotificationPriorityList = [
    {
        value: NotificationPriorities.LOW,
        component: () => TbZzz,
        ...softColors.green,
        tooltip: {
            title: "Düşük",
            description: "Düşük öncelikli bildirimleri içerir.",
        },
    },
    {
        value: NotificationPriorities.MEDIUM,
        component: () => TbBell,
        ...softColors.indigo,
        tooltip: {
            title: "Orta",
            description: "Orta öncelikli bildirimleri içerir.",
        },
    },
    {
        value: NotificationPriorities.HIGH,
        component: () => TbBellRinging,
        ...softColors.yellow,
        tooltip: {
            title: "Yüksek",
            description: "Yüksek öncelikli bildirimleri içerir.",
        },
    },
    {
        value: NotificationPriorities.CRITICAL,
        component: () => TbUrgent,
        ...softColors.red,
        tooltip: {
            title: "Kritik",
            description: "Kritik öncelikli bildirimleri içerir.",
        },
    },
];
